angular.module('shared').factory('SubscriptionPlanLimitService', ["MessageService", function(MessageService) {
  return {
    validate: function(data) {
      if (data.subscription_limit_exceeded) {
        return MessageService.message({
          title: 'Subscription plan limit reached',
          message: data.message.split('<br />'),
          confirmButtonText: 'Ok'
        });
      }
    }
  };
}]);
